var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgElements({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_149_34731)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.1 15.16H0.68C0.31 15.16 0 14.86 0 14.48V0.68C0 0.31 0.3 0 0.68 0H4.1C4.47 0 4.78 0.3 4.78 0.68V14.49C4.78 14.86 4.48 15.17 4.1 15.17V15.16ZM0.69 14.48H4.11V0.68H0.69V14.47V14.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 4.47027H6.13C5.78 4.47027 5.5 4.19027 5.5 3.84027V0.660273C5.5 0.310273 5.78 0.0302734 6.13 0.0302734H14.14C14.49 0.0302734 14.77 0.310273 14.77 0.660273V3.85027C14.77 4.20027 14.49 4.48027 14.14 4.48027V4.47027ZM6.13 3.83027H14.14V0.660273H6.13V3.83027Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.14 15.1404H6.13C5.78 15.1404 5.5 14.8604 5.5 14.5104V11.3204C5.5 10.9704 5.78 10.6904 6.13 10.6904H14.14C14.49 10.6904 14.77 10.9704 14.77 11.3204V14.5104C14.77 14.8604 14.49 15.1404 14.14 15.1404ZM6.13 14.5004H14.14V11.3204H6.13V14.4904V14.5004Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.56973 9.97043H6.14973C5.77973 9.97043 5.46973 9.67043 5.46973 9.29043V5.87043C5.46973 5.50043 5.76973 5.19043 6.14973 5.19043H9.56973C9.93973 5.19043 10.2497 5.49043 10.2497 5.87043V9.29043C10.2497 9.66043 9.94973 9.97043 9.56973 9.97043ZM6.15973 9.29043H9.57973V5.87043H6.15973V9.28043V9.29043Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_149_34731"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.77,
    height: 15.16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgElements);
export default __webpack_public_path__ + "static/media/elements.bc8199fddcad322a952832142c97c7e7.svg";
export { ForwardRef as ReactComponent };